import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

import { useGetFreightModesConfig } from "api/queries/location/useGetFreightModesConfig";
import { useGetServiceDetailsConfig } from "api/queries/location/useGetServiceDetailsConfig";
import Dropdown from "components/v2/Dropdown/Dropdown";

interface OrganisationFormProps {
  extractedPackingListDetails: any;
}

export default function OrganisationForm({ extractedPackingListDetails }: OrganisationFormProps) {
  const intl = useIntl();
  const { watch, setValue } = useFormContext();

  const { data: getServiceDetailsConfigData } = useGetServiceDetailsConfig(
    extractedPackingListDetails?.payment_location_reference_number,
  );
  const { incoterm, incoterm_values } = getServiceDetailsConfigData?.service_options || {};
  const incotermOptions =
    incoterm_values?.map(({ label, value }: { label: string; value: string }) => ({
      label,
      value: value === "none" ? "None" : value.toUpperCase(),
    })) ?? [];

  const { data: freightModeData } = useGetFreightModesConfig(extractedPackingListDetails?.payment_location_reference_number);
  const freightModes = freightModeData?.freight_modes?.available_modes;
  const selectedFreightMode = Object.keys(watch("invited_modes") ?? {})?.[0];
  const handleSelectFreightMode = (value: string) => {
    setValue("invited_modes", { [value]: true });
  };

  return (
    <div className="d-flex gap-3xl">
      {extractedPackingListDetails?.request_type === "shipment" && (
        <div className="flex-1">
          <Dropdown
            label={intl.formatMessage({
              id: "general.freightMode",
              defaultMessage: "Freight mode",
            })}
            required
            alignRight
            options={freightModes || []}
            value={selectedFreightMode || ""}
            onSelect={handleSelectFreightMode}
          />
        </div>
      )}

      <div className="flex-1" style={{ maxWidth: "50%" }}>
        {incoterm !== "off" && (
          <Dropdown
            label={intl.formatMessage({ id: "new-request.service.incoterms", defaultMessage: "Incoterms" })}
            alignRight
            required={incoterm === "mandatory"}
            options={incotermOptions}
            value={watch("service.incoterms") || ""}
            onSelect={(value) => setValue("service.incoterms", value)}
          />
        )}
      </div>
    </div>
  );
}
